import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AuthService } from '../auth.service';
import { SubsidiarySelectorComponent } from '../../shared/subsidiary-selector/subsidiary-selector.component';
import { Subsidiary } from '../../shared/models/subsidiary.model';

@Component({
  selector: 'app-login',
  standalone: false,
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isRegisterMode = false;
  loginForm: FormGroup;
  registerForm: FormGroup;
  loginError: string | null = null;
  registerError: string | null = null;
  isLoggingIn = false;
  isRegistering = false;

  constructor(
    private fb: FormBuilder,
    private authService: AuthService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.loginForm = this.fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required],
      rememberMe: [false]
    });

    this.registerForm = this.fb.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      fullname: ['', Validators.required],
      phone: ['', Validators.required],
      password: ['', [
        Validators.required,
        Validators.minLength(8),
        Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)
      ]],
      confirmPassword: ['', Validators.required],
      acceptTerms: [false, Validators.requiredTrue]
    }, { validators: this.passwordMatchValidator });
  }

  ngOnInit(): void {
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/dashboard']);
    }

    this.isRegisterMode = false;
    setTimeout(() => {
      this.checkFormVisibility();
    }, 0);
  }

  checkFormVisibility(): void {
    const isMobile = window.innerWidth <= 991;
    if (isMobile) {
      const loginContainer = document.querySelector('.login-container');
      const registerContainer = document.querySelector('.register-container');

      if (this.isRegisterMode) {
        loginContainer?.classList.remove('active');
        registerContainer?.classList.add('active');
      } else {
        loginContainer?.classList.add('active');
        registerContainer?.classList.remove('active');
      }
    }
  }

  passwordMatchValidator(form: FormGroup) {
    const password = form.get('password')?.value;
    const confirmPassword = form.get('confirmPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  switchMode(isRegister: boolean): void {
    this.isRegisterMode = isRegister;
    setTimeout(() => {
      this.checkFormVisibility();
    }, 0);
    if (isRegister) {
      this.loginForm.reset({
        rememberMe: false
      });
      this.loginError = null;
    } else {
      this.registerForm.reset({
        acceptTerms: false
      });
      this.registerError = null;
    }
  }

  onLogin(): void {
    this.loginError = null;

    if (this.loginForm.valid) {
      this.isLoggingIn = true;

      const username = this.loginForm.get('username')?.value;
      const password = this.loginForm.get('password')?.value;

      this.authService.login(username, password).subscribe({
        next: (response) => {
          this.isLoggingIn = false;
          if (!response.success) {
            this.loginError = response.message || 'Đăng nhập không thành công';
          }
        },
        error: (error) => {
          this.isLoggingIn = false;
          this.loginError = error.message || 'Đã xảy ra lỗi trong quá trình đăng nhập';
          console.error('Login error:', error);
        }
      });
    } else {
      Object.keys(this.loginForm.controls).forEach(key => {
        const control = this.loginForm.get(key);
        control?.markAsTouched();
      });
    }
  }

  showSubsidiarySelector(subsidiaries: Subsidiary[]): void {
    const dialogRef = this.dialog.open(SubsidiarySelectorComponent, {
      width: '400px',
      data: { subsidiaries }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.authService.setCurrentSubsidiaryId(result);
        this.router.navigate(['/dashboard']);
      } else {
        this.authService.setCurrentSubsidiaryId(subsidiaries[0].id);
        this.router.navigate(['/dashboard']);
      }
    });
  }

  onRegister(): void {
    this.registerError = null;

    if (this.registerForm.valid) {
      this.isRegistering = true;

      const userData = {
        username: this.registerForm.get('username')?.value,
        email: this.registerForm.get('email')?.value,
        fullname: this.registerForm.get('fullname')?.value,
        phone: this.registerForm.get('phone')?.value,
        password: this.registerForm.get('password')?.value,
        register_as_owner: false
      };

      this.authService.register(userData).subscribe({
        next: (response) => {
          this.isRegistering = false;
          if (response.success) {
            alert('Đăng ký thành công! Vui lòng đăng nhập.');
            this.switchMode(false);
          } else {
            this.registerError = response.message || 'Đăng ký không thành công';
          }
        },
        error: (error) => {
          this.isRegistering = false;
          this.registerError = error.message || 'Đã xảy ra lỗi trong quá trình đăng ký';
          console.error('Registration error:', error);
        }
      });
    } else {
      Object.keys(this.registerForm.controls).forEach(key => {
        const control = this.registerForm.get(key);
        control?.markAsTouched();
      });
    }
  }
}